import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

window.Pusher = Pusher;

try {
    Pusher.logToConsole = true; // add this line BEFORE new Echo(...)

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.REACT_APP_PUSHER_APP_KEY,
        cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
        forceTLS: true,
    });
} catch (e) {
    console.error('Echo initialization failed:', e);
}

export default window.Echo;